<div class="d-flex flex-wrap justify-content-center align-items-center">
    <span class="text-center h2 text-white p-2 w-100">Transactions</span>
    <div class="col-12 " *ngFor="let transaction of transactions.slice().reverse()">
        <div class="col-12 col-md-4 card bg-transparent custom-shadow my-2 mx-auto bg-without">
            <div class="card-body">
              <p class="card-title text-light h3">{{transaction.benificiary?.name}}</p>
              <p class="card-text text-light">
                <span *ngIf="transaction.txnHash">
                    Hash : 
                    <a href="{{transaction.sourceCurrency?.explorer}}/{{transaction.txnHash}}" target="_blank" class="text-light">
                        <u>{{transaction.txnHash}}</u>
                    </a>
                    <br />
                </span>
                <span *ngIf="transaction.sourceAmount">
                    Amount : {{transaction.sourceAmount}} {{transaction.sourceCurrency?.name}}<br />
                </span>
                <span *ngIf="transaction.destinationAmount">
                    Amount : {{transaction.destinationAmount}} {{transaction.destinationCurrency?.name}}<br />
                </span>
                <span>
                    ID : {{transaction.id}}<br />
                </span>
                <span [ngClass]="{'text-success': transaction.isPaid, 'text-warning' : transaction.isPaid==null, 'text-danger' : transaction.isPaid==false}" class="h4">
                    {{ transaction.isPaid ? 'Success' : '' }}
                    {{ transaction.isPaid==null ? 'Pending' : ''}}
                    {{ transaction.isPaid==false ? 'Failed' : '' }}
                </span>
              </p>
        </div>
    </div>
</div>

<!-- null -> processing
false -> fail
true -> success -->